'use strict';

DoohApps
.directive('region', ['$compile', '$http','$timeout', function ($compile, $http,$timeout) {
    return {
        restrict: 'A',
        scope: {
            model: '=',
            key: '=',
            settings: '=',
            background: '=',
            backgroundposition: '=',
            orientation: '=',
            aspectratio: '=',
            mode: '=',
            sizeY: '='
        },
        link: function (scope, element, attrs) {
            var positions = {};

            var parent = element.parent();
            if (scope.backgroundposition == undefined) parent.css({ 'background-size': '100% 100%', 'background-repeat': 'no-repeat', 'background-position': 'center center' });
            scope.landscapeMode = true;
            scope.ratio169Mode = true;
            angular.forEach(scope.orientation, function (orient, key) {
                if (orient.ticked == true) {
                    if (orient.res == scope.settings.landscape.value) scope.landscapeMode = true;
                    else scope.landscapeMode = false;
                }
            });
            angular.forEach(scope.aspectratio, function (rat, key) {
                if (rat.ticked == true) {
                    if (rat.res == scope.settings.ratio169.value) scope.ratio169Mode = true;
                    else scope.ratio169Mode = false;
                }
            });
            if (scope.settings == null) scope.settings = {};
            
            scope.mode.landscapeMode = scope.landscapeMode;
            scope.mode.ratio169Mode = scope.ratio169Mode;
            if (scope.landscapeMode) {
                scope.sizeY = 3;
                if (scope.ratio169Mode) scope.maxwidth = 300;
                else scope.maxwidth = 225;
                scope.maxheight = 169;
                parent.css({ 'width': scope.maxwidth + 'px', 'height': scope.maxheight + 'px', 'background-color': 'gray' });
            }
            else {
                scope.sizeY = 5;
                scope.maxwidth = 169;
                if (scope.ratio169Mode) scope.maxheight = 300;
                else scope.maxheight = 225;

                parent.css({ 'width': scope.maxwidth + 'px', 'height': scope.maxheight + 'px', 'background-color': 'gray' });
            }
            scope.unitRatioW = parseFloat((1 / scope.maxwidth).toFixed(5));
            scope.unitRatioH = parseFloat((1 / scope.maxheight).toFixed(5));

            element.css({
                'background-size': '100% 100%'
            });
            scope.InitRegion = function (orientationChange) {
                var orgWidth = scope.orgWidth = scope.model.orgWidth = 80;
                var orgHeight = scope.orgHeight = scope.model.orgHeight = 80;

                var newWidth, newHeight;
                var x = 80, // max width
                    y = 80; // max height
                if (orgWidth > x) {

                    newHeight = Math.round((orgHeight * (x / orgWidth)) * 100) / 100;

                    newWidth = Math.round(x * 100) / 100;
                    if (newHeight > y) {

                        newWidth = newWidth * (y / newHeight);
                        newHeight = Math.round(y * 100) / 100;
                    }
                } else if (orgHeight > y) {

                    newWidth = Math.round((orgWidth * (y / orgHeight)) * 100) / 100;
                    newHeight = Math.round(y * 100) / 100;
                    if (newWidth > x) {

                        newHeight = Math.round((newHeight * (x / newWidth)) * 100) / 100;
                        newWidth = Math.round(x * 100) / 100;
                    }
                }
                else {
                    newHeight = Math.round((orgHeight * (x / orgWidth)) * 100) / 100;

                    newWidth = Math.round(x * 100) / 100;
                }

                if (scope.model.sizeRatio == undefined || orientationChange) {
                    var newH = newHeight / scope.maxheight;
                    var newW = newWidth / scope.maxwidth;
                    scope.model.sizeRatio = {
                        h: newH,
                        w: newW
                    };
                    scope.model.size = {
                        h: newHeight,
                        w: newWidth
                    };
                }

                if (scope.model.PositionRatio == undefined || orientationChange) {
                    scope.model.PositionRatio = {
                    };
                    scope.model.PositionRatio.x = 0;
                    scope.model.PositionRatio.y = 0;
                    scope.model.topLeftX = 0;
                    scope.model.topLeftY = 0;
                }
                var changes = {
                };


                if (scope.model.size != undefined) {
                    changes = {
                        width: (scope.maxwidth * scope.model.sizeRatio.w) + 'px',
                        height: (scope.maxheight * scope.model.sizeRatio.h) + 'px',
                    }
                    // update the element's style
                    element.css(changes);

                } else {
                    changes = {
                        width: newWidth + 'px',
                        height: newHeight + 'px',
                    }
                    // update the element's style
                    element.css(changes);
                }
                
                var widthForMiddleBox = newWidth;
                var heightForMiddleBox = newHeight;
                if (scope.model.size != undefined) {
                    widthForMiddleBox = scope.maxwidth * scope.model.sizeRatio.w;
                    heightForMiddleBox = scope.maxheight * scope.model.sizeRatio.h;
                }
                var middleBoxX = element.find('.middleboxX');
                middleBoxX.css({ 'left': ((widthForMiddleBox / 2) - 5) + 'px' });
                var middleBoxY = element.find('.middleboxY');
                middleBoxY.css({ 'top': ((heightForMiddleBox / 2) - 5) + 'px' });

                var getpos = {};
                if (scope.model.PositionRatio != undefined) {
                    //get position from container size and scaleRatio
                    getpos.x = scope.model.PositionRatio.x * scope.maxwidth; //((scope.maxheight * scope.model.PositionRatio.x) - scope.maxheight) * (-1);
                    getpos.y = scope.model.PositionRatio.y * scope.maxheight; //((scope.maxwidth * scope.model.PositionRatio.y) - scope.maxwidth) * (-1);

                    var changes = {
                        webkitTransform: 'translate(' + getpos.x + 'px, ' + getpos.y + 'px)',
                        transform: 'translate(' + getpos.x + 'px, ' + getpos.y + 'px)',
                    }
                    // translate the element
                    element.css(changes);

                    element.attr('data-x', getpos.x);
                    element.attr('data-y', getpos.y);

                    //---------------------------------

                    scope.model.topLeftX = Math.round((getpos.x * scope.unitRatioW) * 100) / 100;
                    scope.model.topLeftY = Math.round((getpos.y * scope.unitRatioH) * 100) / 100;
                    scope.model.bottomRightX = Math.round(((getpos.x + scope.model.size.w) * scope.unitRatioW) * 100) / 100;
                    scope.model.bottomRightY = Math.round(((getpos.y + scope.model.size.h) * scope.unitRatioH) * 100) / 100;
                    if (scope.model.bottomRightX > 1) scope.model.bottomRightX = 1;
                    if (scope.model.bottomRightY > 1) scope.model.bottomRightY = 1;
                    if ((scope.model.bottomRightX - scope.model.topLeftX) < 0.01) scope.model.bottomRightX = Math.round((scope.model.topLeftX + 0.01) * 100) / 100;
                    if ((scope.model.bottomRightY - scope.model.topLeftY) < 0.01) scope.model.bottomRightY = Math.round((scope.model.topLeftY + 0.01) * 100) / 100;
                    //if (scope.model.bottomRightX < 0.07) scope.model.bottomRightX = 0.07;
                    //if (scope.model.bottomRightY < 0.07) scope.model.bottomRightY = 0.07;
                }
            }
            scope.InitRegion(false);


            interact('#positionBox' + scope.key).draggable({
                // allow dragging of multple elements at the same time
                max: Infinity,

                // call this function on every dragmove event
                onmove: function (event) {

                    var target = event.target,
                        // keep the dragged position in the data-x/data-y attributes
                        x = (parseFloat(target.getAttribute('data-x')) || 1) + event.dx,
                        y = (parseFloat(target.getAttribute('data-y')) || 1) + event.dy;

                    // translate the element
                    target.style.webkitTransform =
                        target.style.transform =
                        'translate(' + x + 'px, ' + y + 'px)';


                    // update the position attributes
                    target.setAttribute('data-x', x);
                    target.setAttribute('data-y', y);

                    positions.x = x;
                    positions.y = y;

                    //---------------------------------

                    scope.model.topLeftX = Math.round((x * scope.unitRatioW) * 100) / 100;
                    scope.model.topLeftY = Math.round((y * scope.unitRatioH) * 100) / 100;
                    scope.model.bottomRightX = Math.round(((x + scope.model.size.w) * scope.unitRatioW) * 100) / 100;
                    scope.model.bottomRightY = Math.round(((y + scope.model.size.h) * scope.unitRatioH) * 100) / 100;
                    if (scope.model.bottomRightY > 1) scope.model.bottomRightY = 1;
                    if (scope.model.bottomRightX > 1) scope.model.bottomRightX = 1;
                    
                    if ((scope.model.bottomRightX - scope.model.topLeftX) < 0.01) scope.model.bottomRightX = Math.round((scope.model.topLeftX + 0.01) * 100) / 100;
                    if ((scope.model.bottomRightY - scope.model.topLeftY) < 0.01) scope.model.bottomRightY = Math.round((scope.model.topLeftY + 0.01) * 100) / 100;
                    scope.$apply();
                },
                // call this function on every dragend event
                onend: function (event) {
                    if (scope.model.PositionRatio == undefined) scope.model.PositionRatio = {};
                    scope.model.PositionRatio.x = parseFloat(positions.x / scope.maxwidth).toFixed(5); //(scope.maxheight - positions.x) / scope.maxheight;
                    scope.model.PositionRatio.y = parseFloat(positions.y / scope.maxheight).toFixed(5); //(scope.maxwidth - positions.y) / scope.maxwidth;
                    scope.$apply();
                },
                inertia: true,
                restrict: {
                    restriction: 'parent',
                    elementRect: {
                        left: 0,
                        right: 1,
                        top: 0,
                        bottom: 1
                    },
                }
            })
                .resizable({
                    restrict: {
                        restriction: 'parent',
                    },
                    
                    onmove: function (event) {

                        var target = event.target;

                        // add the change in coords to the previous width of the target element
                        
                        var newWidth = parseFloat(target.style.width) + (event.dx);
                        var newHeight = parseFloat(target.style.height) + (event.dy);
                        
                        newWidth = Math.round(newWidth * 100) / 100;
                        newHeight = Math.round(newHeight * 100) / 100;

                        var minWidth = scope.maxwidth / 100;
                        var minHeight = scope.maxheight / 100;

                        if (newWidth < minWidth) newWidth = minWidth;
                        if (newHeight < minHeight) newHeight = minHeight;

                        var summWidth = (Math.round((scope.model.topLeftX / scope.unitRatioW) * 100) / 100) + newWidth;
                        var summHeight = (Math.round((scope.model.topLeftY / scope.unitRatioH) * 100) / 100) + newHeight;

                        if (summWidth > scope.maxwidth) {
                            var dt = summWidth - scope.maxwidth;
                            newWidth = newWidth - dt;
                        }
                        if (summHeight > scope.maxheight) {
                            var dt = summHeight - scope.maxheight;
                            newHeight = newHeight - dt;
                        }

                        if (scope.model.LogoAspect)
                            newWidth = Math.round((scope.orgWidth * newHeight / scope.orgHeight) * 100) / 100;

                        if (scope.landscapeMode) {
                            if (newHeight > scope.maxheight) {
                                newHeight = scope.maxheight;
                                if (scope.model.LogoAspect)
                                    newWidth = Math.round((scope.orgWidth * newHeight / scope.orgHeight) * 100) / 100;//newWidth = scope.orgWidth * newHeight / scope.orgHeight;
                            } else if (newWidth > scope.maxwidth) {
                                newWidth = scope.maxwidth;
                            }
                            if (newHeight < minHeight) {
                                newHeight = minHeight;
                                if (scope.model.LogoAspect)
                                    newWidth = Math.round((scope.orgWidth * newHeight / scope.orgHeight) * 100) / 100;//newWidth = scope.orgWidth * newHeight / scope.orgHeight;
                            }
                            else if (newWidth < minWidth) {
                                newWidth = minWidth;
                            }

                        }
                        else {
                            if (newWidth > scope.maxwidth) {
                                newWidth = scope.maxwidth;
                                if (scope.model.LogoAspect)
                                    newHeight = Math.round((scope.orgHeight * newWidth / scope.orgWidth) * 100) / 100;//newWidth = scope.orgWidth * newHeight / scope.orgHeight;
                            } else if (newHeight > scope.maxheight) {
                                newHeight = scope.maxheight;
                            }
                            if (newWidth < minWidth) {
                                newWidth = minWidth;
                                if (scope.model.LogoAspect)
                                    newHeight = Math.round((scope.orgHeight * newWidth / scope.orgWidth) * 100) / 100;//newWidth = scope.orgWidth * newHeight / scope.orgHeight;
                            }
                            else if (newHeight < minHeight) {
                                newHeight = minHeight;
                            }

                        }


                        // update the element's style
                        target.style.width = newWidth + 'px';
                        target.style.height = newHeight + 'px';

                        // translate when resizing from top or left edges
                        newWidth += event.deltaRect.left;
                        newHeight += event.deltaRect.top;


                        var middleBoxX = element.find('.middleboxX');
                        middleBoxX.css({ 'left': ((newWidth / 2) - 5) + 'px' });
                        var middleBoxY = element.find('.middleboxY');
                        middleBoxY.css({ 'top': ((newHeight / 2) - 5) + 'px' });

                        var newH = newHeight / scope.maxheight;
                        var newW = newWidth / scope.maxwidth;

                        scope.model.sizeRatio = {
                            h: newH,
                            w: newW
                        };
                        scope.model.size = {
                            h: newHeight,
                            w: newWidth
                        };

                        scope.model.bottomRightX = (Math.round(((newWidth * scope.unitRatioW) + scope.model.topLeftX) * 100) / 100);
                        scope.model.bottomRightY = (Math.round(((newHeight * scope.unitRatioH) + scope.model.topLeftY) * 100) / 100);

                        if (scope.model.bottomRightX == scope.model.topLeftX) scope.model.bottomRightX = Math.round((scope.model.topLeftX + 0.01) * 100) / 100;
                        if (scope.model.bottomRightY == scope.model.topLeftY) scope.model.bottomRightY = Math.round((scope.model.topLeftY + 0.01) * 100) / 100;

                        if (scope.model.bottomRightX > 1) scope.model.bottomRightX = 1;
                        if (scope.model.bottomRightY > 1) scope.model.bottomRightY = 1;
                        if ((scope.model.bottomRightX - scope.model.topLeftX) < 0.01) scope.model.bottomRightX = Math.round((scope.model.topLeftX + 0.01) * 100) / 100;
                        if ((scope.model.bottomRightY - scope.model.topLeftY) < 0.01) scope.model.bottomRightY = Math.round((scope.model.topLeftY + 0.01) * 100) / 100;
                        
                        scope.$apply();
                    }
                });

            // allow more than one interaction at a time
            interact.maxInteractions(Infinity);

            scope.$watch(function () { if (scope.background == undefined) return undefined; else return scope.background }, function (newValue, oldValue) {
                
                if (newValue != undefined) {
                    if (newValue.Image != undefined) {
                        parent.css({ 'background-image': 'url("' + newValue.Image.FileURL + '")' });
                    }
                    else if (newValue.ValueArray != undefined && newValue.ValueArray.length > 0) {
                        if (newValue.ValueArray[0].Media != undefined) {
                            if (newValue.ValueArray[0].Media.AssetType == 'image') parent.css({ 'background-image': 'url("' + newValue.ValueArray[0].Media.FileURL + '")' });
                            else parent.css({ 'background-image': 'url("' + newValue.ValueArray[0].Media.IconUrl + '")' });
                        }
                        else if (newValue.ValueArray[0].Image != undefined) parent.css({ 'background-image': 'url("' + newValue.ValueArray[0].Image.FileURL + '")' });
                        else if (newValue.ValueArray[0].Video != undefined) parent.css({ 'background-image': 'url("' + newValue.ValueArray[0].Video.IconUrl + '")' });
                    }

                    angular.forEach(scope.backgroundposition, function (opt, key) {
                        if (opt.ticked) {
                            switch (opt.label.toLowerCase()) {
                                case 'center':
                                    if (scope.background != undefined) {
                                        var resolution;
                                        if (scope.background.Image != undefined) resolution = scope.background.Image.Resolution;
                                        else if (scope.background.ValueArray != undefined && scope.background.ValueArray.length > 0) {
                                            if (scope.background.ValueArray[0].Media != undefined) resolution = scope.background.ValueArray[0].Media.Resolution;
                                            else if (scope.background.ValueArray[0].Image != undefined) resolution = scope.background.ValueArray[0].Image.Resolution;
                                            else if (scope.background.ValueArray[0].Video != undefined) resolution = scope.background.ValueArray[0].Video.Resolution;
                                        }
                                    }
                                    if (resolution != undefined) {
                                        var splitRes = resolution.split('/');
                                        if (splitRes.length > 1) {
                                            var scaleSize1 = splitRes[0] / 6.4;
                                            var scaleSize2 = splitRes[1] / 6.4;
                                            parent.css({ 'background-size': scaleSize1 + 'px ' + scaleSize2 + 'px', 'background-repeat': 'no-repeat', 'background-position': 'center center' });
                                        }
                                        else parent.css({ 'background-size': 'initial', 'background-repeat': 'no-repeat', 'background-position': 'center center' });
                                    }
                                    else parent.css({ 'background-size': 'initial', 'background-repeat': 'no-repeat', 'background-position': 'center center' });
                                    break;
                                case 'tile':
                                    if (scope.background != undefined) {
                                        var resolution;
                                        if (scope.background.Image != undefined) resolution = scope.background.Image.Resolution;
                                        else if (scope.background.ValueArray != undefined && scope.background.ValueArray.length > 0) {
                                            if (scope.background.ValueArray[0].Media != undefined) resolution = scope.background.ValueArray[0].Media.Resolution;
                                            else if (scope.background.ValueArray[0].Image != undefined) resolution = scope.background.ValueArray[0].Image.Resolution;
                                            else if (scope.background.ValueArray[0].Video != undefined) resolution = scope.background.ValueArray[0].Video.Resolution;
                                        }
                                    }
                                    if (resolution != undefined) {
                                        var splitRes = resolution.split('/');
                                        if (splitRes.length > 1) {
                                            var scaleSize1 = splitRes[0] / 6.4;//16:9 1920x1080
                                            var scaleSize2 = splitRes[1] / 6.4;//16:9 1920x1080
                                            parent.css({ 'background-size': scaleSize1 + 'px ' + scaleSize2 + 'px', 'background-repeat': 'repeat', 'background-position': 'left top' });
                                        }
                                        else parent.css({ 'background-size': 'initial', 'background-repeat': 'repeat', 'background-position': 'left top' });
                                    }
                                    else parent.css({ 'background-size': 'initial', 'background-repeat': 'repeat', 'background-position': 'left top' });
                                    break;
                                default:
                                    break;

                            }
                        }
                    })
                    //'width': '300px', 'height': '169px', 
                }

            }, true)
            scope.$watch(function () { if (scope.backgroundposition == undefined) return undefined; else return scope.backgroundposition }, function (newValue, oldValue) {
                
                if (newValue != undefined) {
                    angular.forEach(newValue, function (opt, key) {
                        if (opt.ticked) {
                            switch (opt.label.toLowerCase()) {
                                case 'fill':
                                    parent.css({ 'background-size': 'cover', 'background-repeat': 'no-repeat', 'background-position': 'center center' });
                                    break;
                                case 'center':
                                    if (scope.background != undefined) {
                                        var resolution;
                                        if (scope.background.Image != undefined) resolution = scope.background.Image.Resolution;
                                        else if (scope.background.ValueArray != undefined && scope.background.ValueArray.length > 0) {
                                            if (scope.background.ValueArray[0].Media != undefined) resolution = scope.background.ValueArray[0].Media.Resolution;
                                            else if (scope.background.ValueArray[0].Image != undefined) resolution = scope.background.ValueArray[0].Image.Resolution;
                                            else if (scope.background.ValueArray[0].Video != undefined) resolution = scope.background.ValueArray[0].Video.Resolution;
                                        }
                                    }
                                    if (resolution != undefined) {
                                        var splitRes = resolution.split('/');
                                        if (splitRes.length > 1) {
                                            var scaleSize1 = splitRes[0] / 6.4;
                                            var scaleSize2 = splitRes[1] / 6.4;
                                            parent.css({ 'background-size': scaleSize1 + 'px ' + scaleSize2 + 'px', 'background-repeat': 'no-repeat', 'background-position': 'center center' });
                                        }
                                        else parent.css({ 'background-size': 'initial', 'background-repeat': 'no-repeat', 'background-position': 'center center' });
                                    }
                                    else parent.css({ 'background-size': 'initial', 'background-repeat': 'no-repeat', 'background-position': 'center center' });
                                    break;
                                case 'fit':
                                    parent.css({ 'background-size': 'contain', 'background-repeat': 'no-repeat', 'background-position': 'center center' });
                                    break;
                                case 'stretch':
                                    parent.css({ 'background-size': '100% 100%', 'background-repeat': 'no-repeat', 'background-position': 'center center' });
                                    break;
                                case 'tile':
                                    if (scope.background != undefined) {
                                        var resolution;
                                        if (scope.background.Image != undefined) resolution = scope.background.Image.Resolution;
                                        else if (scope.background.ValueArray != undefined && scope.background.ValueArray.length > 0) {
                                            if (scope.background.ValueArray[0].Media != undefined) resolution = scope.background.ValueArray[0].Media.Resolution;
                                            else if (scope.background.ValueArray[0].Image != undefined) resolution = scope.background.ValueArray[0].Image.Resolution;
                                            else if (scope.background.ValueArray[0].Video != undefined) resolution = scope.background.ValueArray[0].Video.Resolution;
                                        }
                                    }
                                    if (resolution != undefined) {
                                        var splitRes = resolution.split('/');
                                        if (splitRes.length > 1) {
                                            var scaleSize1 = splitRes[0] / 6.4;
                                            var scaleSize2 = splitRes[1] / 6.4;
                                            parent.css({ 'background-size': scaleSize1 + 'px ' + scaleSize2 + 'px', 'background-repeat': 'repeat', 'background-position': 'left top' });
                                        }
                                        else parent.css({ 'background-size': 'initial', 'background-repeat': 'repeat', 'background-position': 'left top' });
                                    }
                                    else parent.css({ 'background-size': 'initial', 'background-repeat': 'repeat', 'background-position': 'left top' });
                                    break;
                                default:
                                    break;

                            }
                        }
                    })
                }
            }, true)

            scope.$watch(function () { if (scope.orientation == undefined) return undefined; else return scope.orientation }, function (newValue, oldValue) {
                if (newValue != undefined) {
                    
                    var changed = false;
                    if (oldValue == undefined) changed = true;
                    else {
                        if (typeof newValue == 'string') return;
                        for (var i = 0; i < newValue.length; i++) {
                            if (newValue[i].ticked != oldValue[i].ticked) changed = true;
                        }
                    }
                    
                    if (changed) {
                    scope.landscapeMode = true;
                    angular.forEach(newValue, function (orient, key) {
                        if (orient.ticked == true) {
                            if (orient.res == scope.settings.landscape.value) scope.landscapeMode = true;
                            else scope.landscapeMode = false;
                        }
                    });

                    if (scope.landscapeMode) {
                        if (scope.ratio169Mode) scope.maxwidth = 300;
                        else scope.maxwidth = 225;
                        scope.maxheight = 169;
                        $timeout(function () {
                            parent.css({ 'width': scope.maxwidth + 'px', 'height': scope.maxheight + 'px', 'background-color': 'gray' });
                        }, 250);
                        scope.sizeY = 3;
                    }
                    else {
                        scope.maxwidth = 169;
                        if (scope.ratio169Mode) scope.maxheight = 300;
                        else scope.maxheight = 225;
                        $timeout(function () {
                            parent.css({ 'width': scope.maxwidth + 'px', 'height': scope.maxheight + 'px', 'background-color': 'gray' });
                        }, 250);

                        scope.sizeY = 5;
                    }

                    scope.unitRatioW = parseFloat((1 / scope.maxwidth).toFixed(5));
                    scope.unitRatioH = parseFloat((1 / scope.maxheight).toFixed(5));
                        
                    scope.mode.landscapeMode = scope.landscapeMode;
                    scope.InitRegion(true);
                }
                    
                }
            }, true);

            scope.$watch(function () { if (scope.aspectratio == undefined) return undefined; else return scope.aspectratio }, function (newValue, oldValue) {
                
                if (newValue != undefined) {
                    
                    var changed = false;
                    if (oldValue == undefined) changed = true;
                    else {
                        if (typeof newValue == 'string') return;
                        for (var i = 0; i < newValue.length; i++) {
                            if (newValue[i].ticked != oldValue[i].ticked) changed = true;
                        }
                    }
                    if (changed) {
                    scope.ratio169Mode = true;
                    angular.forEach(newValue, function (rat, key) {
                        if (rat.ticked == true) {
                            if (rat.res == scope.settings.ratio169.value) scope.ratio169Mode = true;
                            else scope.ratio169Mode = false;
                        }
                    });

                    if (scope.landscapeMode) {
                        if (scope.ratio169Mode) scope.maxwidth = 300;
                        else scope.maxwidth = 225;
                        scope.maxheight = 169;
                        parent.css({ 'width': scope.maxwidth + 'px', 'height': scope.maxheight + 'px', 'background-color': 'gray' });
                    }
                    else {
                        scope.maxwidth = 169;
                        if (scope.ratio169Mode) scope.maxheight = 300;
                        else scope.maxheight = 225;
                        parent.css({ 'width': scope.maxwidth + 'px', 'height': scope.maxheight + 'px', 'background-color': 'gray' });
                    }

                    scope.unitRatioW = parseFloat((1 / scope.maxwidth).toFixed(5));
                    scope.unitRatioH = parseFloat((1 / scope.maxheight).toFixed(5));
                        
                    scope.mode.ratio169Mode = scope.ratio169Mode;
                    scope.InitRegion(true);
                }
                    
                }
            }, true);


        }
    };
}]);